<template>
  <div class="p-2 surface-border border-bottom-2 formgrid grid m-0">
    <div class="col-4 text-left flex align-items-center">
      <span>Kód pre komunikáciu: <strong>[Pifema #{{store.order.orderCode}}]</strong></span>
      <PrimevueButton 
        v-tooltip.top="'Skopírovať kód'" 
        @click="copyOrderCodeToClipboard" 
        text 
        rounded 
        class="ml-2"
        style="padding: 0.125rem; min-width: auto; width: auto;"
      >
        <i class="pi pi-copy" style="font-size: 1.2rem;"></i>
      </PrimevueButton>
    </div>
    <!-- <div class="pb-2 pt-2">Odberateľ: 
        {{ store.order.user.company }} 
      (<em>{{ store.order.user.firstName }}
      {{ store.order.user.lastName }}, {{ store.order.user.phone }}</em>)
     
    </div>
     -->
    <div class="col-4 text-center justify-content-center align-items-center">Aktuálny stav:
         <PrimevueTag class="p-2 ml-1 font-medium text-base justify-content-center" :value="store.order.currentState.name"
           :style="{ backgroundColor: store.order.currentState.color }" />
    </div>
    
    <div class="p-2 col-4 justify-content-end text-right" v-if="store.order.id > 0">
      <em>Objednávka naposledy uložená
        <i class="pi pi-clock"></i>
        {{ Utils.parseToSlovakDateTime(store.order.modifiedAt) }} - {{
          store.order.modifiedUser.firstName
        }}
        {{ store.order.modifiedUser.lastName }}
      </em>
    </div>
  </div>
  <div class="p-2 surface-border border-bottom-2 flex flex-nowrap align-items-center">
    
    <div class="flex-1 flex-column md:flex-row flex pb-2 pt-2 font-medium text-xl ">
        <div class="flex w-5 uppercase">Objednávka #{{ store.order.orderCode }} </div>
        <!--
        <div class="flex w-10 uppercase">{{ store.order.description }}
          <PrimevueButton type="button" v-tooltip.top="{ value: 'Upraviť popis' }" icon="pi pi-pencil" @click="this.editedOrder = !this.editedOrder" text raised size="small" class="ml-2"/>
        </div>
         -->
        <div class="flex w-4 ml-1"><i class="pi pi-user pr-2"></i> {{ store.order.customer.lastName }}
          <PrimevueButton type="button" v-tooltip.top="{ value: 'Editácia zákazníka' }" icon="pi pi-pencil" @click="this.editedOrder = !this.editedOrder" text raised size="small" class="ml-2"/>
        </div>
        <div class="flex w-4 ml-1" v-if="store.order.customer.city"><i class="pi pi-home pr-2"></i> {{ store.order.customer.city }} </div>
    </div>
    
    <div class="flex-1 md:flex-2 flex flex-row align-items-center justify-content-center gap-2">
      <div v-if="store.order.id > 0" class="w-full flex flex-row align-items-center justify-content-center gap-2">
        
          <!-- <label for="state" class="mr-2">Stav</label> -->
          <FloatLabel class="flex-1">
            <PrimevueSelect
                  inputId="state"
                  v-model="this.selectState"
                  :options="store.orderStates"
                  optionLabel="name"
                  optionValue="id"
                  class="w-full"
                  @change="confirmState()"
            />
            <label for="state" class="">Zmeniť stav</label>
          </FloatLabel>
          <!-- placeholder="Zmeniť stav objednávky"
          <PrimevueButton label="Zmeniť stav" raised 
                          class="w-3 ml-2 uppercase" severity="info" icon="pi pi-save"
                          @click="Utils.changeState(this.currentState)"
           />
           -->
          <Fieldset v-if="this.$route.params.orderId > 0" legend="Prehľad stavov" class="flex-1" toggleable :collapsed="true">
              <ul>
                <li v-for="history in store.orderHistory" v-bind:key="history.id">
                  <i class="pi pi-clock"></i>
                  {{ Utils.formatToSlovak(history.changeDate) }}
                  <PrimevueTag :value="history.state.name" :style="{ backgroundColor: history.state.color }"/>
                  - {{ history.user.firstName }} {{ history.user.lastName }}
                </li>
              </ul>
          </Fieldset>
      </div>
    </div>

  </div>
  <div class="flex flex-column align-items-center justify-content-center pt-2 pb-2">
    
    <PrimevueCard  v-if="this.editedOrder" class="sm:w-10 md:w-10 lg:w-10 xl:w-10 m-2">

      <template #content>
        
        <form @submit.prevent="submitHandler" name="userForm">
           <PrimevuePanel header="Zákazník" class="border-solid border-1 surface-border">
              <div class="formgrid grid">
            <!--     <div class="field col-12 md:col-6 lg:col-3">
                      <label for="first-name">Meno</label>
                      <InputText class="w-full"
                        :class="`${v$.store.order.customer.firstName.$error ? 'bg-red-200' : ''}`"
                        :invalid="v$.store.order.customer.firstName.$error"
                        v-model="store.order.customer.firstName"
                        type="text"
                        name="first-name"
                        id="first-name"
                        >
                      </InputText>
                      <div
                            v-for="(error, index) of v$.store.order.customer.firstName.$errors"
                            :key="index"
                            class="text-sm font-italic text-red-400"
                      >
                        {{ error.$message }}
                      </div>                      
                  </div>
            --> 
                  <div class="field col-12 md:col-12 lg:col-6">
                    <label for="last-name">Meno</label>
                    <InputText class="w-full"
                      :class="`${v$.store.order.customer.lastName.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.store.order.customer.lastName.$error"                    
                      v-model="store.order.customer.lastName"
                      type="text"
                      name="last-name"
                      id="last-name"
                      >
                    </InputText>
                    <div
                          v-for="(error, index) of v$.store.order.customer.lastName.$errors"
                          :key="index"
                          class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>                      
                  </div>
                  
                  <div class="field col-12 md:col-6 lg:col-3">
                    <label for="email">Email</label>
                    <InputText class="w-full"
                      :class="`${v$.store.order.customer.email.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.store.order.customer.email.$error"                              
                      v-model="store.order.customer.email"
                      type="email"
                      name="email"
                      id="email"
                      >
                    </InputText>
                    <div
                          v-for="(error, index) of v$.store.order.customer.email.$errors"
                          :key="index"
                          class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>                                          
                  </div>    
                  
                  <div class="field col-12 md:col-6 lg:col-3">
                    <label for="phone">Mobil</label>
                    <InputText class="w-full"
                      :class="`${v$.store.order.customer.phone.$error ? 'bg-red-200' : ''}`"
                      :invalid="v$.store.order.customer.phone.$error"                    
                      v-model="store.order.customer.phone"
                      type="text"
                      name="phone"
                      id="phone"
                      >
                    </InputText>
                    <div
                          v-for="(error, index) of v$.store.order.customer.phone.$errors"
                          :key="index"
                          class="text-sm font-italic text-red-400"
                    >
                      {{ error.$message }}
                    </div>                                                
                  </div>                        
              </div>

              <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-6">
                    <label for="company">Spoločnosť</label>
                    <InputText class="w-full"
                      v-model="store.order.customer.company"
                      type="text"
                      name="company"
                      id="company"
                      >
                    </InputText>
                </div>
                <div class="field col-12 md:col-3 lg:col-3">
                  <label for="ico">IČO</label>
                  <InputText class="w-full"
                    v-model="store.order.customer.ico"
                    type="text"
                    name="ico"
                    id="ico"
                    >
                  </InputText>
                </div>
                <div class="field col-12 md:col-3 lg:col-3">
                  <label for="vat">DIČ</label>
                  <InputText class="w-full"
                    v-model="store.order.customer.vat"
                    type="text"
                    name="vat"
                    id="vat"
                    >
                  </InputText>
                </div>
              </div>

              <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label for="addressFirst">Ulica a číslo</label>
                    <InputText class="w-full"
                      
               
                      v-model="store.order.customer.addressLine1"
                      type="text"
                      name="addressFirst"
                      id="addressFirst"
                      >
                    </InputText>
                    
           
              </div>

                <div class="field col-12 md:col-6 lg:col-3">
                  <label for="addressSecond">Doplnok k adrese</label>
                  <InputText class="w-full"
                    v-model="store.order.customer.addressLine2"
                    type="text"
                    name="addressSecond"
                    id="addressSecond"
                    >
                  </InputText>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                  <label for="city">Mesto/Obec</label>
                  <InputText class="w-full"
                    :class="`${v$.store.order.customer.city.$error ? 'bg-red-200' : ''}`"
                    :invalid="v$.store.order.customer.city.$error"                    
                    v-model="store.order.customer.city"
                    type="text"
                    name="city"
                    id="city"
                    >
                  </InputText>
                  <div
                        v-for="(error, index) of v$.store.order.customer.city.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>                                              
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                  <label for="zip">PSČ</label>
                  <InputText class="w-full"
                    :class="`${v$.store.order.customer.zip.$error ? 'bg-red-200' : ''}`"
                    :invalid="v$.store.order.customer.zip.$error"                    
                    v-model="store.order.customer.zip"
                    type="text"
                    name="zip"
                    id="zip"
                    >
                  </InputText>
                  <div
                        v-for="(error, index) of v$.store.order.customer.zip.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
                  >
                    {{ error.$message }}
                  </div>                                              
                </div>
              </div>

              <div class="formgrid grid">
                <div class="field col-12">
                    <label for="comment">Komentár</label>
                    <InputText class="w-full"
                      v-model="store.order.customer.comment"
                      type="text"
                      name="comment"
                      id="comment"
                      >
                    </InputText>
                </div>
              </div>
            </PrimevuePanel>

          <!-- <div class="mt-3 mb-3 border-solid border-1 surface-border"></div> -->
            
          <div class="mt-2 flex flex-wrap justify-content-center gap-3">
              <PrimevueButton type="submit" label="Uložiť" text raised class="uppercase"/>
              <router-link to="/mod-orders/orders">
                    <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
              </router-link>
          </div>
        </form>

      </template>
    </PrimevueCard>
    
    <div v-if="this.$route.params.orderId > 0" class="flex flex-row flex-wrap my-2 ml-4 gap-3 w-full">
      <div class="sm:w-12 md:w-5 lg:w-5 xl:w-5">
        <CortizoProform :orderId="this.$route.params.orderId"></CortizoProform>
      </div>
      
      <div class="sm:w-12 md:w-6 lg:w-6 xl:w-6">
        <AttachmentsByType :orderId="this.$route.params.orderId"></AttachmentsByType>
      </div>
    </div>
    
    <PrimevueCard v-if="this.$route.params.orderId > 0" class="w-full my-2 ml-4" >
      <template #title>
        <div class="font-medium text-xl">
              Rezervácia kusov
        </div>
      </template>
      <template #content>
        <Fieldset legend="Rezervovanie kusov" toggleable :collapsed="true">
          <ReservedItems :orderId="String(this.$route.params.orderId)" :reserved="true" :search="false"></ReservedItems>
       </Fieldset>
        <Fieldset legend="Zoznam rezervovaných kusov" toggleable :collapsed="true" style="border:5px solid rgb(0,182,147)">
           <ReservedItems :orderId="String(this.$route.params.orderId)" :reserved="false" :search="false"></ReservedItems>
        </Fieldset>
      </template>
    </PrimevueCard>

    <div v-if="this.$route.params.orderId > 0" class="flex flex-row flex-wrap my-2 ml-4 justify-content-start w-full">
      <PrimevueCard  v-if="store.user.department.id != 1" class="w-xs:w-12 md:w-6 lg:w-6 xl:w-6 m-2" >
        <template #title>
          <div class="font-medium text-xl">
                Komunikácia so zákazníkmi a dodávateľmi
          </div>
        </template>
        <template #content>
          <div class="mb-3">
            <EditorMessage :orderId="String(this.$route.params.orderId)" :orderCode="String(store.order.orderCode)" :orderDesc="store.order.description"></EditorMessage>
          </div>
          <CommunicationList :internal="false" :orderId="String(this.$route.params.orderId)"></CommunicationList>
        </template>
      </PrimevueCard>
      
      <PrimevueCard  class="w-xs:w-12 md:w-5 lg:w-5 xl:w-5 m-2" >
        <template #title>
          <div class="font-medium text-xl">
                Komunikácia v rámci firmy
          </div>
        </template>
        <template #content>
          <div class="mb-3">
            <EditorMessageInt :orderId="String(this.$route.params.orderId)"></EditorMessageInt>
          </div>
           <CommunicationList :internal="true" :orderId="String(this.$route.params.orderId)"></CommunicationList>
        </template>
      </PrimevueCard>
     
    </div>
    
  </div>
  <ConfirmDialog></ConfirmDialog>
</template>


<script lang="ts">
import {store} from "@/components/store";
import router from "@/router";
import Security from "@/components/security";
import notie from "notie/dist/notie";
import PrimevueButton from 'primevue/button';
import PrimevueSelect from 'primevue/dropdown';
import PrimevueCard from 'primevue/card';
import PrimevuePanel from 'primevue/panel';
import PrimevueTag from "primevue/tag";
import FloatLabel from 'primevue/floatlabel';
import CommunicationList from "@/components/CommunicationList.vue";
import AttachmentsByType from "@/components/AttachmentsByType.vue";   
import ReservedItems from "@/components/ReservedItems.vue";
import EditorMessage from "@/components/EditorMessage.vue";
import EditorMessageInt from "@/components/EditorMessageInt.vue";
import CortizoProform from "@/components/CortizoProform.vue";
import Utils from './utils';
import { email, required, helpers, minLength, alpha, numeric, maxLength  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Fieldset from "primevue/fieldset";
import {emiter} from '../main';

const mustBe421 = (value : string) => !helpers.req(value) || value.startsWith('+421')
//const notRequired = (value : string) => !helpers.req(value)


export default {
  components: {
    PrimevueButton,
    PrimevueSelect,
    PrimevueCard, 
    PrimevueTag,
    PrimevuePanel,
    FloatLabel,
    CommunicationList,
    EditorMessage,
    EditorMessageInt,
    AttachmentsByType,
    ReservedItems,
    Fieldset,
    CortizoProform,
  },
  name: "OrderEdit",
  data() {
    return {
      store,
      modifiedUser: {},
      //currentState: {name:"Nový"},
      selectState: null,
      routeParams: null,
      editedOrder: false,
      dialogClosedByAccept: false,
      
    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  validations () {
    return {
      store: {order: {customer: 
                     {
                      //firstName: {required: helpers.withMessage('Meno nesmie byť prázdne', required),
                      //            minLength: helpers.withMessage('Meno musí obsahovať min. 2 znaky', minLength(2)),
                      //           }, 
                      lastName:  { required: helpers.withMessage('Meno nesmie byť prázdne', required),
                                  minLength: helpers.withMessage('Meno musí obsahovať min. 2 znaky', minLength(2)),
                                  
                                 },  
                      phone:     { mustBe421: helpers.withMessage('Telefón musí začínať +421', mustBe421)},
                      email:     { email: helpers.withMessage('Nesprávny email', email)},
                      //addressLine1: { required: helpers.withMessage('Ulica a číslo nemôžu byť prázdne', required)},
                      city:      { required: helpers.withMessage('Mesto/obec nemôže byť prázdne', required)},
                      zip:       { 
                      //             required: helpers.withMessage('PSČ nemôžu byť prázdne', required),
                                   numeric:  helpers.withMessage('PSČ môže obsahovať len čísla', numeric),
                                   maxLength:helpers.withMessage('PSČ môže obsahovať len čísla', maxLength(5))},                                            
                    }}}
 
      
    }
  },
  computed: {
    Utils() {
      return Utils
    },
    orderCodeText() {
      return `[Pifema #${store.order.orderCode}]`
    },
  },
  mounted() {
   
    if (Security.requireToken()){
      
      store.selectModul = this.$route.path.split("/")[1]
      this.routeParams = this.$route.params
      
      this.loadData()


    }
  },
  methods: {

    loadData(){
      
      if (parseInt(String(this.routeParams.orderId), 10) > 0) {
       
         const orderId = String(this.routeParams.orderId)

        fetch(store.Api_url + "/v1/order/" + orderId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
               
                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'warning',
                  text: "Objednávku sa nepodarilo načítať",
                  position: "top"
                })
              } else {
                store.order = responseData.data
                
                if (!store.order.description) {
                  store.order.description = ""
                }

                //let modifiedDateTemp = new Date(responseData.data.modifiedAt)
                
                //if(Utils.isDSTInEffect(modifiedDateTemp)){
                //  modifiedDateTemp = Utils.minusOneHour(modifiedDateTemp)
                //}else{
                  //modifiedDateTemp = Utils.minusOneHour(modifiedDateTemp)
                //  modifiedDateTemp = Utils.minusOneHour(modifiedDateTemp)
                //}
                //store.order.modifiedAt = modifiedDateTemp;

                this.scanFoldersAddAttachments()
                
                emiter.emit("reloadAttByType")
                
                Utils.getOrderStates()
                Utils.updateOrderHistory()
                               

              }
            })
            .catch((error) => {
              notie.alert({
                  type: 'warning',
                  text: "Objednávku sa nepodarilo načítať: "+error,
                  position: "top"
                })
            })
      }else{
        
        store.order = {... store.order_default}
        this.editedOrder = true
        store.order.modifiedUser = store.user
        Utils.getOrderStates()
        Utils.updateOrderHistory()
        
      }

    },

   
    scanFoldersAddAttachments(){

      const orderId = String(this.routeParams.orderId)

      fetch(store.Api_url + "/v1/add-attachments/" + orderId, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              //this.$emit('error', responseData.message);
              notie.alert({
                type: 'warning',
                text: "Nedodarilo sa pridať prílohy do objednávky",
                position: "top"
              })
            } 
            emiter.emit("reloadAttByType")
      })
      .catch((error) => {
        notie.alert({
            type: 'warning',
            text: "Nedodarilo sa pridať prílohy do objednávky: "+error,
            position: "top"
          })
      })       
    },

    confirmState() {
      const lastItem = store.orderHistory.length > 0 ? store.orderHistory[store.orderHistory.length - 1].state.id : 0;

      if(lastItem != this.selectState){
        this.dialogClosedByAccept = false;
        this.$confirm.require({
            message: 'Naozaj chcete zmeniť stav objednávky?',
            header: 'Zmena stavu objednávky',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Áno",
            rejectLabel: "Nie",

            accept: () => {
              Utils.changeState(this.selectState);
              this.dialogClosedByAccept = true;

            },
            reject: () => {
              this.selectState = null;
            },
            onHide: () => {
              if(!this.dialogClosedByAccept){
                this.selectState = null;
              }
              this.dialogClosedByAccept = false;
            }
        });
      }
    },
    async submitHandler() {
      // Validovať len customer fields, nie proformy
      const result = await this.v$.store.order.customer.$validate()
      if (!result) {
       // notify user form is invalid
        return
      }

      const orderId = parseInt(String(this.$route.params.orderId), 10)
 
      let method = "POST"
      let url = "/v1/order/"  
      //?userId="+store.user.id
      if (orderId > 0){
        method = "PUT"
        url = "/v1/order/" + orderId 
        // + "?userId="+store.user.id
      }

      store.order.customerFirstName = store.order.customer.firstName
      store.order.customerLastName = store.order.customer.lastName
      store.order.customerEmail = store.order.customer.email

      fetch(store.Api_url + url, Security.requestOptions(method, store.order))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {

              //this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              //console.log("order:", responseData.data);
              store.order = responseData.data
              router.push("/mod-orders/order/"+String(store.order.id));

              notie.alert({
                type: 'success',
                text: "Objednávka bola uložená"
              })

              
            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri uložení objednávky" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení objednávky" + error
            })
          })

    },
    copyOrderCodeToClipboard() {
      const codeText = this.orderCodeText;
      
      // Try to use modern Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codeText).then(() => {
          notie.alert({
            type: 'success',
            text: `Kód "${codeText}" bol skopírovaný do schránky`,
            position: 'top'
          });
        }).catch((err) => {
          console.error('Failed to copy text: ', err);
          // Fallback to old method
          this.fallbackCopyTextToClipboard(codeText);
        });
      } else {
        // Fallback for older browsers
        this.fallbackCopyTextToClipboard(codeText);
      }
    },
    fallbackCopyTextToClipboard(text: string) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          notie.alert({
            type: 'success',
            text: `Kód "${text}" bol skopírovaný do schránky`,
            position: 'top'
          });
        } else {
          notie.alert({
            type: 'error',
            text: 'Nepodarilo sa skopírovať kód do schránky',
            position: 'top'
          });
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        notie.alert({
          type: 'error',
          text: 'Nepodarilo sa skopírovať kód do schránky',
          position: 'top'
        });
      }
      
      document.body.removeChild(textArea);
    },
  },

  beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
          this.routeParams = to.params
          store.selectModul = this.$route.path.split("/")[1]
        
          this.loadData()  

          next()
        }
  },
}
</script>



<style scoped>

</style>

